// export everything in order to be AoT compatible
export * from './json-editor.module';
export * from './shared/interfaces';
export * from './shared/services';
export * from './shared/pipes';
export * from './shared/classes';
